import { combineReducers } from 'redux'
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';

import ThingSpeakSource from '../models/source/thingSpeak';
import AirSource from '../models/source/air';
import MapProperties from '../models/map/Properties';
import GovernanceData from '../models/data/governance';
import AirQualityData from '../models/data/airQuality/index';
import SchoolData from '../models/data/schoolData';
import GovernanceSource from '../models/source/governance';
import JGRICMYCSource from '../models/source/jgrIcmyc';

import ViewSettings from '../models/settings';
import CivicSource from '../models/source/civic';

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  geoFire: function (state = {}, action) {
    return state;
  },
  database: function (state = {}, action) {
    return state;
  },
  thingSpeak: ThingSpeakSource.reducer,
  openAQ: AirSource.reducer,
  map: MapProperties.reducer,
  governanceData: GovernanceData.reducer,
  airQuality: AirQualityData.reducer,
  schoolData: SchoolData.reducer,
  gov: GovernanceSource.reducer,
  jgrIcmyc: JGRICMYCSource.reducer,
  civic: CivicSource.reducer,
  viewSettings: ViewSettings.reducer,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js